import axios from 'axios'
import * as config from './config'
import {FGetCookie} from './util'

let qs = require('qs')
let platAxios = axios.create({
  baseURL: config.PLATFORMHOST
})
const fAxios = (type, data, fCallback, cancel) => {
  let uid = FGetCookie('uid')
  let cid = FGetCookie('cid')
  let sig = FGetCookie(config.SIG)
  let base = {
    cid,
    uid,
    sig
  }
  data = Object.assign(base, data);
  let uploadData = {
    action: type,
    content: JSON.stringify(data)
  }
  uploadData = qs.stringify(uploadData)
  platAxios.post('',uploadData, {
    cancelToken: new axios.CancelToken(function executor(c) {
      if(cancel){
        cancel(c)
      }
    })
  })
    .then(function (response) {
      if (response.statusText === 'OK') {
        fCallback(response.data)
      }
    })
    .catch(function (err) {
      console.log(err)
    })
}
export default fAxios



// WEBPACK FOOTER //
// ./src/common/plat-request.js